import { Directive } from '@angular/core';
import { Observable } from 'rxjs';

import { OpenSsoLinkDirective } from '@design/open-sso-link/directives/open-sso-link.directive';

@Directive({
  selector: '[itcOpenSsoCertifyTaxLink]',
})
export class OpenSsoCertifyTaxLinkDirective extends OpenSsoLinkDirective {
  protected override openSsoLink(): Observable<void> {
    return this.openSsoLinkService.openCertifyTax();
  }
}
